/* CWV HubSpot form — loads the v2 embed only when the form is near the viewport. */
(function () {
  'use strict';

  var loaders = {};

  function loadEmbed(region) {
    var src = 'https://js-' + region + '.hsforms.net/forms/embed/v2.js';
    if (loaders[src]) return loaders[src];
    loaders[src] = new Promise(function (resolve, reject) {
      if (window.hbspt && window.hbspt.forms) { resolve(); return; }
      var s = document.createElement('script');
      s.src = src;
      s.charset = 'utf-8';
      s.type = 'text/javascript';
      s.async = true;
      s.onload = function () { resolve(); };
      s.onerror = function () { delete loaders[src]; reject(new Error('HubSpot embed failed to load')); };
      document.head.appendChild(s);
    });
    return loaders[src];
  }

  function showError(el) {
    var panel = el.closest('.cwv-hs__panel');
    var err = panel ? panel.querySelector('[data-cwv-hs-error]') : null;
    var loading = el.querySelector('[data-cwv-hs-loading]');
    if (loading) loading.remove();
    if (err) err.hidden = false;
  }

  function create(el) {
    if (el.cwvStarted) return;
    el.cwvStarted = true;
    var region = (el.getAttribute('data-region') || 'na2').trim();
    var portalId = (el.getAttribute('data-portal-id') || '').trim();
    var formId = (el.getAttribute('data-form-id') || '').trim();
    if (!portalId || !formId) { showError(el); return; }

    var timer = setTimeout(function () {
      if (!el.querySelector('form, iframe')) showError(el);
    }, 15000);

    loadEmbed(region).then(function () {
      if (!window.hbspt || !window.hbspt.forms) throw new Error('hbspt missing');
      window.hbspt.forms.create({
        region: region,
        portalId: portalId,
        formId: formId,
        target: '#' + el.id,
        onFormReady: function () {
          clearTimeout(timer);
          var loading = el.querySelector('[data-cwv-hs-loading]');
          if (loading) loading.remove();
          el.classList.add('is-ready');
        }
      });
    }).catch(function () {
      clearTimeout(timer);
      showError(el);
    });
  }

  function init(scope) {
    var els = (scope || document).querySelectorAll('[data-cwv-hs]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, create);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          io.unobserve(entry.target);
          create(entry.target);
        }
      });
    }, { rootMargin: '800px 0px' });
    Array.prototype.forEach.call(els, function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
